module.exports = __webpack_public_path__ + "img/bird-14-right.991b81d0.png";